(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "../setting", "../../location/schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("../setting"), require("../../location/schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.setting, global.schema);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _setting, _schema) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.usersSchema = _exports.userSchema = void 0;

  /**
   * Schema for a single user
   * @type {schema.Entity}
   */
  var userSchema = new _normalizr.schema.Entity(_setting.userEntityKey, {
    locations: [_schema.locationSchema]
  });

  /**
   * Schema for multiple users
   * @type {Array<schema.Entity>}
   */
  _exports.userSchema = userSchema;
  var usersSchema = [userSchema];
  _exports.usersSchema = usersSchema;
});